// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1bICO","title":"Info_title__3SN4a","selects":"Info_selects__1wvGz","requiredAsterisk":"Info_requiredAsterisk__26UC_"};